// extracted by mini-css-extract-plugin
module.exports =  {"person":"xbR4tc6rzPsdfqdwGLXU"};